var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserOctagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5667 7.15002V12.85C17.5667 13.7833 17.0667 14.65 16.2583 15.125L11.3083 17.9834C10.5 18.45 9.49999 18.45 8.68332 17.9834L3.73332 15.125C2.92499 14.6584 2.42499 13.7917 2.42499 12.85V7.15002C2.42499 6.21668 2.92499 5.34998 3.73332 4.87498L8.68332 2.01666C9.49165 1.54999 10.4917 1.54999 11.3083 2.01666L16.2583 4.87498C17.0667 5.34998 17.5667 6.20835 17.5667 7.15002Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.16667C11.0724 9.16667 11.9417 8.29734 11.9417 7.22499C11.9417 6.15263 11.0724 5.28336 10 5.28336C8.92766 5.28336 8.05835 6.15263 8.05835 7.22499C8.05835 8.29734 8.92766 9.16667 10 9.16667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 13.8833C13.3334 12.3833 11.8417 11.1667 10 11.1667C8.15835 11.1667 6.66669 12.3833 6.66669 13.8833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOctagon);
export default __webpack_public_path__ + "static/media/user-octagon.0126b86106d217428864987a5b8b3a87.svg";
export { ForwardRef as ReactComponent };